export function getTicketBankItems() {
  return `query($eventId:String!){
  ticketBank {
    get(eventId: $eventId) {
      _id
      name,
      eventId,
      price,
      promoterId,
      description
      referral,
      quantity
      bought
      cancelled,
      checkedIn,
      activated,
      available,
      enabled,
      referral,
      goOnSaleAfter
    }
  }
}
`;
}

export function getTicketBankItemsAsString() {
  return `query($eventId:String!){
  ticketBank {
    getAsString(eventId: $eventId)
  }
}
`;
}

export function getTicketBankItemsPrivate() {
  return `query($eventId:String!,$promoterId:String!){
  ticketBank {
    getPrivate(eventId: $eventId,promoterId: $promoterId) {
      _id
      name,
      eventId,
      price,
      promoterId,
      quantity
      bought
      cancelled,
      checkedIn,
      description,
      activated,
      available,
      enabled,
      referral
    }
  }
}
`;
}

export function getAllTicketBankItems() {
  return `query($eventId:String!){
  ticketBank {
    get(eventId: $eventId) {
      _id
      name,
      eventId,
      price,
      promoterId,
      quantity
      bought
      cancelled,
      checkedIn,
      activated,
      description,
      available,
      enabled,
      referral
    }
  }
}
`;
}

export function createTicketBankItem() {
  return `mutation($ticketBankItem:TicketBankItemInput!, $allocateIndividually:Boolean!){
  ticketBank {
    create(ticketBankItem: $ticketBankItem, allocateIndividually: $allocateIndividually) {
      _id
      name
      quantity,
      price,
      bought
      cancelled,
      eventId,
      promoterId,
      description,
      checkedIn,
      activated,
      enabled,
      referral
    }
  }
}
`;
}

export function createTicketBankItemWithoutWebsocket() {
  return `mutation($ticketBankItem:TicketBankItemInput!){
  ticketBank {
    createWithoutWS(ticketBankItem: $ticketBankItem) {
      _id
      name
      quantity,
      price,
      bought
      cancelled,
      eventId,
      promoterId,
      checkedIn,
      activated,
      description,
      enabled,
      referral
    }
  }
}
`;
}

/**
 * Need to provide id and quantity inside :ticketBankItem object provided
 * in "variables" key -> method FetchGraphQL
 */
export function updateQuantity() {
  return `
 mutation ($ticketBankItem:TicketBankItemInput!){
  ticketBank {
    update(ticketBankItem: $ticketBankItem) {
      _id
      quantity
    }
  }
}
`;
}

/**
 * Need to provide _id  inside :ticketBankItem object provided
 * in "variables" key -> method FetchGraphQL
 */
export function enable() {
  return `
 mutation ($ticketBankItem:TicketBankItemInput!){
  ticketBank {
    update(ticketBankItem: $ticketBankItem) {
      _id
      name,
      price,
      quantity
      bought
      cancelled,
      checkedIn,
      activated,
      available,
      enabled
    }
  }
}
`;
}

/**
 * Need to provide _id  inside :ticketBankItem object provided
 * in "variables" key -> method FetchGraphQL
 */
export function disable() {
  return `
 mutation ($ticketBankItem:TicketBankItemInput!){
  ticketBank {
    update(ticketBankItem: $ticketBankItem) {
      _id
      name
      quantity
      bought,
      price,
      cancelled,
      checkedIn,
      activated,
      available,
      enabled
    }
  }
}
`;
}

/**
 * Need to provide _id  inside :ticketBankItem object provided
 * in "variables" key -> method FetchGraphQL
 */
export function deleteTicketItem() {
  return `
 mutation ($ticketBankItem:TicketBankItemInput!){
  ticketBank {
    delete(ticketBankItem: $ticketBankItem)
  }
}
`;
}



// WEBPACK FOOTER //
// ./src/components/graphql/queries/ticketBank.ts